import { Link } from 'react-router-dom'
import type { ObjectNavigation } from './objectContext'

export default function ObjectContextNavigation({
  navigation,
  loading = false,
  unavailable = false,
  partial = false,
  onRetry,
}: {
  navigation: ObjectNavigation
  loading?: boolean
  unavailable?: boolean
  partial?: boolean
  onRetry: () => void
}) {
  if (
    !navigation.choices.length &&
    !navigation.below &&
    !navigation.workspaces.length &&
    !(navigation.fundLike && (loading || unavailable || partial))
  )
    return null
  return (
    <nav aria-label="Object record navigation" data-testid="object-context-navigation">
      {navigation.choices.map((choice) => (
        <div className="drawer-section" key={choice.id} data-testid="object-context-choice">
          <div className="sentence">{choice.label}</div>
          <div className="doors">
            <Link className="vbtn" to={choice.overviewHref}>
              Subchain Overview
            </Link>
            <Link className="vbtn" to={choice.recordHref}>
              Subchain Record
            </Link>
          </div>
        </div>
      ))}
      {navigation.below ? (
        <div className="drawer-section">
          <Link className="vbtn" to={navigation.below.href} data-testid="object-below-record">
            {navigation.below.label}
          </Link>
        </div>
      ) : null}
      {navigation.workspaces.map((workspace) => (
        <div className="drawer-section" key={workspace.fundId} data-testid="object-fund-workspace">
          <div className="sentence">{workspace.label}</div>
          {workspace.reference ? (
            <div className="nav-muted" data-testid="object-fund-reference">
              Fund reference: {workspace.reference}
            </div>
          ) : null}
          <div className="sentence">
            Its own Record: {workspace.ownCounts.proven} of {workspace.ownCounts.total} evidence
            demands proven · {workspace.ownCounts.breaks} open breaks
          </div>
          <div className="doors">
            <Link className="vbtn" to={workspace.href}>
              Open fund Record
            </Link>
          </div>
        </div>
      ))}
      {navigation.fundLike && loading ? <p role="status">Loading related fund records…</p> : null}
      {navigation.fundLike && unavailable ? (
        <p role="status">
          Related fund records unavailable.{' '}
          <button className="vbtn" type="button" onClick={onRetry}>
            Retry
          </button>
        </p>
      ) : null}
      {navigation.fundLike && partial && !unavailable ? (
        <p>Some related fund records are unavailable.</p>
      ) : null}
    </nav>
  )
}
